import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

/**
 * Zaustavlja kviz (ručni prekid ili automatski kada vreme istekne)
 * @returns true ako je zaustavljanje uspešno, false ako nije
 */
const stopQuizAPI = async (): Promise<boolean> => {
  try {
    const config: AxiosRequestConfig = {
      method: "POST",
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/politehnika/stop-quiz`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/politehnika/stop-quiz`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response: AxiosResponse = await axios(config);
    
    console.log("✅ Kviz je zaustavljen:", response.data);
    
    // Backend vraća CommonResponse: { code, message, description, data: { success: true } }
    return response.data.data.success;
  } catch (error) {
    console.error("❌ Greška pri zaustavljanju kviza:", error);
    return false;
  }
};

export default stopQuizAPI;

